import { render, staticRenderFns } from "./LogIndexView.vue?vue&type=template&id=effa7a6e&scoped=true&"
import script from "./LogIndexView.vue?vue&type=script&lang=js&"
export * from "./LogIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effa7a6e",
  null
  
)

export default component.exports